import { dot, Fn, fract, sin, vec2 } from "three/tsl"

export const random = Fn(([st]: [any]) => {
  return fract(sin(dot(st.xy, vec2(12.9898, 78.233))).mul(43758.5453123))
})
